function AriaLiveRegion() {
  return (
    <blockquote className="p-4 bg-white">
      <h4 className="h6 mb-3">What It Means</h4>
      <p>An ARIA alert role or live region is present.</p>
      <h4 className="h6 mb-3">Why It Matters</h4>
      <p>ARIA live regions and alerts can be used to dynamically inform screen reader users of content updates.</p>
      <h4 className="h6 mb-3">What To Do</h4>
      <p>Ensure the live region is properly tested and presents important, succinct content updates. A live region should not be used if focus is set to the updated page element.</p>
    </blockquote>
  )
}

export default AriaLiveRegion